export const FALLBACK_PRICING = {
    "dsa": {
        "price": 499,
        "mrp": 2999
    },
    "systemDesign": {
        "price": 399,
        "mrp": 1999
    },
    "react": {
        "price": 199,
        "mrp": 1499
    },
    "javascript": {
        "price": 199,
        "mrp": 1499
    },
    "angular": {
        "price": 199,
        "mrp": 1499
    },
    "interviewPrep": {
        "price": 399,
        "mrp": 2499
    },
    "frontendSystemDesign": {
        "price": 299,
        "mrp": 2499
    },
    "aiFundamentals": {
        "price": 799,
        "mrp": 1499
    },
    "aiEngineering": {
        "price": 999,
        "mrp": 2499
    },
    "aiInterviewPrep": {
        "price": 999,
        "mrp": 4999
    },
    "foundation": {
        "price": 799,
        "mrp": 4999
    },
    "frontend": {
        "price": 999,
        "mrp": 4999
    },
    "backend": {
        "price": 999,
        "mrp": 4999
    },
    "ai": {
        "price": 999,
        "mrp": 4999
    },
    "completeInterviewKit": {
        "price": 999,
        "mrp": 4999
    }
};

// Re-export pricing from context for backward compatibility
export { PRICING, usePricing, PricingProvider } from '../context/PricingContext';

// Set to true to enable Razorpay payment flow
// Set REACT_APP_SHOW_PAYMENT_FLOW=false in .env to disable payments and make content free
export const SHOW_PAYMENT_FLOW = process.env.REACT_APP_SHOW_PAYMENT_FLOW !== 'false';
